<template>
  <div class="aboutus-w">
    <img src="../../assets/img/about/aboutus-t.png" alt="">
    <div class="about-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="公司介绍" name="first">
          <div class="first-c">
            <img src="../../assets/img/about/about-t2.png" alt="恒安卫士（深圳）电子科技发展有限公司" align="left">
            <p>恒安卫士（深圳）电子科技发展有限公司是北京恒安卫士保安服务有限公司全资子公司，目前北京恒安卫士保安服务有限公司在全国二十个以上的城市开展轨道交通安检服务，作为全国规模最大的轨道交通安检服务供应商，同时也是轨道交通安检设备的实际使用者，我们对各家的安检产品优劣非常了解，2016年北京恒安卫士保安服务有限公司出资在深圳成立全资子公司恒安卫士（深圳）电子科技发展有限公司，自己研发制造自己品牌的X光机系列产品。</p>
            <p>古人云：“鸟随鸾凤飞腾远，人伴贤良品自高！”。恒安卫士（深圳）电子科技发展有限公司自创立以来就积极开展业内交流、对外合作，大力推进产品的纵向延伸和横向发展，积极引进新技术、新产品，在掌握大量业内信息、技术的同时，积极参与安检系统边缘领域的探索与研究，实现产品的无限优化、系统的智能升级，真正做到“运筹帷幄，决胜千里”！
公司成立的初衷就是要为公共安全防范事业做出最大的贡献，为平安城市、平安地铁、平安中国尽自己的一份责任。科学的设计、严格的管理、严肃的工作作风和良好的售后服务，获得了众多客户的好评。为市场的繁荣作贡献是我们经营者的最高理念，积极的参与市场的开发和新技术的维护是我们最大的快事，顾客满意是我们的宗旨，也是企业发展的光明之路。恒安卫士（深圳）电子科技发展有限公司开业至今，一直本着以人为本，以科技名牌为导向的原则，凭借高起点，高品质及热情周到的服务，亲近顾客，服务至上，高度重视信用并锐意创新及时引进科技新成果，全力投入竞争，取得了良好的效果。</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="荣誉资质" name="second">
          <div class="second-c">
            <div class="content-l">
              <div class="contl-t">恒安荣誉资质</div>
              <div class="contl-ry" v-for="(i, k) in honorData" :key="k">
                <i class="el-icon-star-on"></i><span>{{i}}</span>
              </div>
            </div>
            <div class="content-r">
              <img v-for="(i, k) in honorImg" :src="i" :key="k">
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: 'aboutus',
  data () {
    return {
      activeName: 'first',
      honorData: ['辐射安全许可证', '安检机HA-6550检验报告', '安检机HA-6550D检验报告', '安检机HA-100100检验报告', '安检机HA-100100D检验报告', '计算机信息系统安全服务等级证', '. . .'],
      honorImg: [require('../../assets/img/about/honor1.jpg'), require('../../assets/img/about/honor2.jpg'), require('../../assets/img/about/honor3.jpg'), require('../../assets/img/about/honor4.jpg'), require('../../assets/img/about/honor5.jpg'), require('../../assets/img/about/honor6.jpg'), require('../../assets/img/about/honor7.jpg'), require('../../assets/img/about/honor8.jpg')]
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}
</script>
<style scoped>
.aboutus-w>img{
  width: 100%;
  height: 400px;
}
.about-tabs{
  width: 1200px;
  margin: 20px auto;
}
.first-c{
  margin-top: 70px;
}
.first-c img{
  margin: 10px 100px 40px 0;
}
.first-c p{
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  line-height: 40px;
  text-indent: 30px;
}
.second-c{
  width: 100%;
  margin-top: 70px;
  margin-bottom: 108px;
  display: flex;
  justify-content: space-between;
}
.content-l{
  width: 230px;
}
.contl-t{
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  margin-bottom: 54px;
}
.contl-ry{
  height: 19px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 19px;
  margin-bottom: 20px;
}
.contl-ry span{
  padding-left: 4px;
}
.content-r{
  width: 705px;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}
.content-r img{
  width: 210px;
  height: auto;
  margin-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/about.vue